(() => {
  if (window.ondelieHeaderReady) return;
  window.ondelieHeaderReady = true;

  let updateTimer;
  const closeDelay = 220;

  const stabiliseMenus = (scope = document) => {
    scope.querySelectorAll('.site-header--ondelie hover-disclosure').forEach((item) => {
      if (item.dataset.ondelieHoverReady === 'true') return;
      if (typeof item.showDisclosure !== 'function' || typeof item.hideDisclosure !== 'function') return;

      item.dataset.ondelieHoverReady = 'true';

      const showDisclosure = item.showDisclosure.bind(item);
      const hideDisclosure = item.hideDisclosure.bind(item);
      let closeTimer;

      const cancelClose = () => window.clearTimeout(closeTimer);

      item.showDisclosure = () => {
        cancelClose();
        showDisclosure();
      };

      item.hideDisclosure = () => {
        cancelClose();
        closeTimer = window.setTimeout(() => {
          const focusInside = item.contains(document.activeElement);
          if (item.matches(':hover') || focusInside) return;
          hideDisclosure();
        }, closeDelay);
      };

      item.addEventListener('mouseenter', cancelClose);
      item.querySelector('.header__dropdown')?.addEventListener('mouseenter', cancelClose);
    });
  };

  const renderCount = (count) => {
    document.querySelectorAll('[data-ondelie-cart-count]').forEach((element) => {
      element.textContent = count;
    });

    document.querySelectorAll('.site-header--ondelie .cart__toggle').forEach((toggle) => {
      toggle.classList.toggle('cart__toggle--has-items', count > 0);
    });
  };

  const requestCount = async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        headers: {Accept: 'application/json'},
        credentials: 'same-origin',
      });

      if (!response.ok) return;
      const cart = await response.json();
      renderCount(Number(cart.item_count) || 0);
    } catch (error) {
      // Keep the server-rendered value if the cart endpoint is unavailable.
    }
  };

  const queueUpdate = () => {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(requestCount, 80);
  };

  ['theme:cart:refresh', 'theme:cart:added', 'theme:cart:updated', 'theme:cart:change'].forEach((eventName) => {
    document.addEventListener(eventName, queueUpdate);
  });

  window.addEventListener('pageshow', queueUpdate);

  if (customElements.get('hover-disclosure')) {
    stabiliseMenus();
  } else {
    customElements.whenDefined('hover-disclosure').then(() => stabiliseMenus());
  }
  document.addEventListener('shopify:section:load', (event) => stabiliseMenus(event.target));
})();
